import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DIMENSIONS } from 'services/layoutManager';
import { MicrosoftApi } from 'services/microsoft';
import { BloxButton } from 'styled_components/Common/BloxButton';
import { SigningServiceApi } from 'services/signing';
import { ActionButton } from 'styled_components/Common/ActionButton';
import { DocumentsDisplay } from 'styled_components/Account/DocumentsDisplay';
import { PortraitModalComponent } from 'styled_components/Common/PortraitModalComponent';
import { ModalFooter } from 'styled_components/Common/ModalFooter';
import { ReleaseApi } from 'services/release';
import { Permissions } from 'services/permissions';
import TextInput from 'sub_components/Common/BloxTextInput';
import { Utils } from 'services/utils';
import { MENU as PROFILE_MENU } from 'utils/ProfileConstants';
import { SITE_PAGES, SITE_MODULES, ErrorMessage } from 'utils/CommonConstants';
import BloxPage from 'sub_components/Layout/BloxPage';
import ComponentWrapper from 'sub_components/Layout/ComponentWrapper';
import CustomCarousel from 'sub_components/Common/CustomCarousel';
import { RESOLUTIONS } from 'services/config';
import { CompanyProfileApi } from 'services/companyProfile';
import { updateModule, updatePage, addPageToBreadCrumbs } from 'actions/siteTracking';
import { INPUT_TYPES } from 'utils/CommonConstants';
import { updatePermissions } from 'actions/permissions';
import { getUserPermissions, setUserPermissions } from 'services/user';
const emailValidations = [
	{ message: 'Required field', pattern: /.+/ },
	{ message: 'Please enter a valid email address.', pattern: /^[^@\s]+@[^@\s]+\.[^@\s]+$/ },
];
const LAYOUT_CONFIG = {
	[RESOLUTIONS.LOW]: {
		documents: { x: 1, y: 24, dim: DIMENSIONS.TEN_BY_TWELVE },
		selection: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_TWELVE },
	},
	[RESOLUTIONS.MED]: {
		documents: { x: 1, y: 34, dim: DIMENSIONS.TEN_BY_TEN },
		selection: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_TEN },
	},
	[RESOLUTIONS.HIGH]: {
		documents: { x: 1, y: 54, dim: DIMENSIONS.TEN_BY_TEN },
		selection: { x: 1, y: 4, dim: DIMENSIONS.TWO_BY_TEN },
	},
};

class DocumentsPage extends Component {
	constructor(props) {
		super(props);
		this.companyApi = new CompanyProfileApi();
		this.releaseApi = new ReleaseApi();
		this.state = {
			error: false,
			releases: null,
			viewing: 'General',
			pages: null,
			displayFiles: null,
			isLoading: true,
			oneDriveTabs: null,
			oneDriveSOCFiles: null,
			viewNDAModal: false,
			requestorEmail: '',
			validNDA: false,
			selectedDocumentId: null,
			sendingDocument: false,
		};
	}

	componentDidMount() {
		const {
			updateModule,
			permissions,
			updatePage,
			addPageToBreadCrumbs,
			auth_status: { user },
			site,
		} = this.props;
		updatePage(SITE_PAGES.PROFILE[PROFILE_MENU.DOCUMENTS]);
		addPageToBreadCrumbs(SITE_PAGES.PROFILE[PROFILE_MENU.DOCUMENTS], SITE_MODULES.ACCOUNT);
		if (site?.module !== 'ACCOUNT' || !permissions?.permissions) {
			this.getModulePages();
		}
		updateModule(SITE_MODULES.ACCOUNT);

		this.getOneDrive();
		this.getOrgOneDrive();
		this.requestReleases();
		this.checkNDAFile();

		if (user) {
			this.setState({ requestorEmail: user?.contactDetails?.email });
		}
	}

	onChange = event => {
		const { value } = event.target;
		this.setState({ [event.target.name]: value });
	};

	getOneDrive = () => {
		MicrosoftApi.getOneDrive()
			.then(response => {
				const validResponse = response.status === 200 && response.data?.driveItemList;

				if (validResponse) {
					this.setState({ oneDriveTabs: response?.data?.driveItemList });
				}
			})
			.catch(() => {});
	};

	getOrgOneDrive = () => {
		const {
			setModalContent,
			company_info: {
				customer: { id },
			},
		} = this.props;
		MicrosoftApi.getOrgOneDriveItem(id)
			.then(response => {
				const validResponse = response.status === 200 && response.data?.driveItemList;
				if (validResponse) {
					this.setState({
						oneDriveOrgFiles: response?.data?.driveItemList,
						displayFiles: response?.data?.driveItemList,
						isLoading: false,
					});
				} else {
					setModalContent(
						'TIMEOUT_CLOSE',
						'Error getting your organization documents. Please try again later or contact our support team.',
					);
					this.setState({ isLoading: false });
				}
			})
			.catch(() => {
				setModalContent(
					'TIMEOUT_CLOSE',
					'Error getting your organization documents. Please try again later or contact our support team.',
				);
				this.setState({ isLoading: false });
			});
	};

	getCompanyOrgCode = () => {
		const {
			auth_status: { memberships },
			company_info: {
				customer: { id },
			},
		} = this.props;

		if (!memberships) {
			return null;
		}

		const currentMembership = memberships.filter(
			membership => Number(membership.organizationId) === Number(id),
		);

		return currentMembership[0]?.orgCode;
	};

	sendNDADocument = async () => {
		const { requestorEmail } = this.state;
		const {
			company_info: {
				customer: { id: organizationId },
			},
			auth_status: {
				user: { id },
			},
		} = this.props;

		const orgCode = this.getCompanyOrgCode();
		const createDocumentParams = {
			documentName: `${orgCode}-${id}-NDA`,
			templateName: 'DCBLOX-Compliance-NDA',
		};
		const response = await SigningServiceApi.createDocumentRequest(createDocumentParams);

		const ndaRequest = {
			documentId: response?.data?.documentId,
			senderEmail: 'dcb-processor@dcblox.com',
			type: 'NDA',
			subject: 'NDA',
			message: ' NDA',
			datacenters: null,
			organizationId,
			signers: [
				{
					email: requestorEmail,
					expiration_days: 31,
					reminder: 3,
					role: 'Signer 1',
				},
			],
		};
		const button = (
			<BloxButton
				className='buttons41'
				id='okay'
				text='OKAY'
				module='account'
				enabled={true}
				onClick={() => {}}
				cypressId='okay'
			/>
		);
		SigningServiceApi.sendSingleSigningRequest(ndaRequest)
			.then(response => {
				const validResponse = response.status === 200 && response.data?.success;
				const { requestorEmail } = this.state;
				const { setModalContent } = this.props;

				if (validResponse) {
					setModalContent(
						'TIMEOUT_CLOSE',
						`We have sent your requested document to ${requestorEmail}.`,
						button,
					);
					this.setState({ sendingDocument: false });
				} else {
					setModalContent('TIMEOUT_CLOSE', ErrorMessage, button);
					this.setState({ sendingDocument: false });
				}
			})
			.catch(() => {
				setModalContent('TIMEOUT_CLOSE', ErrorMessage, button);
				this.setState({ sendingDocument: false });
			});
	};
	disableDocuments = () => {
		const documents = document.querySelectorAll('.document');
		if (documents && documents.length) {
			documents.forEach(document => document.classList.add('disabled'));
		}
		this.setState({ sendingDocument: true });
	};
	sendDocument = async documentId => {
		const {
			auth_status: { user } = {},
			company_info: { customer: { id } = {} } = {},
			site,
		} = this.props;
		this.disableDocuments();

		const { requestorEmail } = this.state;

		const browserInfo = await Utils.getClientParams(site);
		const ip_address = await Utils.getIPAddress();
		const fileRequest = {
			email: requestorEmail,
			documentId,
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			browser: browserInfo,
			ip_address,
			user_id: user?.id,
			org_id: id,
		};
		const button = (
			<BloxButton
				className='buttons41'
				id='okay'
				text='OKAY'
				module='account'
				enabled={true}
				onClick={() => {}}
				cypressId='okay'
			/>
		);
		MicrosoftApi.getFileRequest(fileRequest)
			.then(response => {
				const validResponse = response.status === 200 && response.data?.fileSent;
				const { requestorEmail } = this.state;
				const { setModalContent } = this.props;

				if (validResponse) {
					setModalContent(
						'TIMEOUT_CLOSE',
						`We have sent your requested document to ${requestorEmail}.`,
						button,
					);
					this.setState({ sendingDocument: false });
				} else {
					setModalContent('TIMEOUT_CLOSE', ErrorMessage, button);
					this.setState({ sendingDocument: false });
				}
			})
			.catch(() => {
				setModalContent('TIMEOUT_CLOSE', ErrorMessage, button);
				this.setState({ sendingDocument: false });
			});
	};
	getOneDriveItem = id => {
		const {
			setModalContent,
			company_info: {
				customer: { id: organizationId },
			},
		} = this.props;
		MicrosoftApi.getOneDriveItem({ itemId: id, organizationId })
			.then(response => {
				const validResponse = response.status === 200 && response.data?.driveItemList;

				if (validResponse) {
					this.setState({
						displayFiles: response?.data?.driveItemList,
						isLoading: false,
						oneDriveSOCFiles: response?.data?.driveItemList,
					});
				} else {
					setModalContent(
						'TIMEOUT_CLOSE',
						'Error getting SOC documents. Please try again later or contact our support team.',
					);
					this.setState({ isLoading: false });
				}
			})
			.catch(() => {
				setModalContent(
					'TIMEOUT_CLOSE',
					'Error getting SOC documents. Please try again later or contact our support team.',
				);
				this.setState({ isLoading: false });
			});
	};

	getModulePages = async () => {
		const {
			updatePermissions,
			auth_status: {
				user: { id: userId },
			},
			company_info: {
				customer: { id: orgId },
			},
		} = this.props;

		const permissions = getUserPermissions('account');
		if (!permissions) {
			const response = await Permissions.getModulePermissions(3, userId, orgId);
			if (response && !response.data.error) {
				setUserPermissions('account', response.data.pages);
				updatePermissions(response.data.pages);
			}
		} else {
			updatePermissions(permissions);
		}
	};

	updateView = view => {
		const { oneDriveTabs, oneDriveOrgFiles, oneDriveSOCFiles } = this.state;
		const { auth_status: { user: { contactDetails: { email } = {} } = {} } = {} } = this.props;
		this.setState({ viewing: view, displayFiles: null, isLoading: true });
		switch (view) {
			case 'SOC':
				if (!oneDriveSOCFiles) {
					const socDriveFolder = oneDriveTabs.filter(item => item?.name === 'SOC');
					this.getOneDriveItem(socDriveFolder[0]?.id);
				} else {
					this.setState({ displayFiles: oneDriveSOCFiles, isLoading: false });
				}
				break;
			case 'General':
				this.setState({ displayFiles: oneDriveOrgFiles, isLoading: false, requestorEmail: email });
				break;
			case 'releases':
				this.setState({ isLoading: false });
				break;
			default:
				break;
		}
	};
	informUser = () => {
		const { requestorEmail } = this.state;
		const { setModalContent } = this.props;
		setModalContent(
			'TIMEOUT_CLOSE',
			`Thank you! We have received your request and are working on sending the requested document to ${requestorEmail}.`,
		);
	};
	informUserSendingSigningDoc = () => {
		const { requestorEmail } = this.state;
		const { setModalContent } = this.props;
		setModalContent(
			'TIMEOUT_CLOSE',
			`Thank you! We have received your request and are working on sending the requested document to ${requestorEmail} to be signed.`,
		);
	};
	downloadDriveItem = driveItem => {
		const fileName = driveItem?.name;
		if (!fileName.includes('SOC')) {
			this.informUser();
			this.sendDocument(driveItem.id);
		} else {
			this.setState({ selectedDocumentId: driveItem.id });
			this.toggleNDAModal();
		}
	};

	toggleNDAModal = () => {
		const { showNDAModal } = this.state;
		this.setState({ showNDAModal: !showNDAModal });
	};

	requestReleases = () => {
		const { auth_status } = this.props;
		const {
			user: { id },
		} = auth_status;

		return this.releaseApi
			.getAllReleases(id)
			.then(response => {
				const { releases } = response.data;

				if (!Utils.isValidResponse(response)) {
					this.setState({ releasesError: response.data.error });
				} else {
					this.setState({ releases });
				}
			})
			.catch(error => this.setState({ releasesError: error }));
	};

	checkNDAFile = () => {
		const { company_info: { customer: { id } = {} } = {} } = this.props;
		this.companyApi
			.checkValidNDA(id)
			.then(response => {
				const validResponse = response.status === 200 && response.data?.hasValidNDA;
				if (validResponse) {
					this.setState({
						validNDA: true,
					});
				} else {
					this.setState({
						validNDA: false,
					});
				}
			})
			.catch(() => {
				this.setState({
					validNDA: false,
				});
			});
	};

	NDAModalBody = () => {
		const { requestorEmail, validNDA } = this.state;
		let ndaMessage = '';
		let note = '';
		if (validNDA) {
			ndaMessage = 'We have your NDA on file.';
			note = 'Please select continue to receive this document to the email above.';
		} else {
			ndaMessage = 'We do not have your NDA on file.';
			note = 'Please select continue and we will send an NDA form to the email above.';
		}

		return (
			<div className='nda-content'>
				<TextInput
					disabled={true}
					placeholder=''
					active={true}
					type={INPUT_TYPES.INPUT}
					label='Email'
					name='requestorEmail'
					value={requestorEmail}
					validations={emailValidations}
					onChange={this.onChange}
					markComplete={() => {}}
					cypressId='nda-email'
				/>
				<div className='nda-message labels21'>{ndaMessage}</div>
				<div className='nda-note body10'>{note}</div>
			</div>
		);
	};
	handleSendNDASigningDoc = () => {
		this.toggleNDAModal();
		this.informUserSendingSigningDoc();
		this.sendNDADocument();
	};
	handleSendDoc = selectedDocumentId => {
		this.toggleNDAModal();
		this.informUser();
		this.sendDocument(selectedDocumentId);
	};
	getSize = breakpoint => {
		let size = 'large';
		if (breakpoint === RESOLUTIONS.MED) {
			size = 'medium';
		} else if (breakpoint === RESOLUTIONS.HIGH) {
			size = 'medium';
		}

		return size;
	};
	renderHeader() {
		return (
			<div className='default-header'>
				<div className='body10'>
					This is a secure document. To access this document we must have a valid NDA on file for
					your organization.
				</div>
			</div>
		);
	}

	render() {
		const { breakpoint, location, setModalContent, permissions: pages } = this.props;
		const {
			viewing,

			displayFiles,
			isLoading,
			releases,
			showNDAModal,
			validNDA,
			selectedDocumentId,
			sendingDocument,
		} = this.state;

		const hasDownloadDocumentAccess = Permissions.checkComponentAccess(
			pages,
			'Overview',
			'download-documents',
		);
		const oneDriveTabs = [{ name: 'General' }, { name: 'SOC' }, { name: 'releases' }];
		return (
			<BloxPage
				name='page documents-page'
				layout={LAYOUT_CONFIG[breakpoint]}
				breakpoint={breakpoint}
				location={location}
				setModalContent={setModalContent}
			>
				<div key={`selection`} className='selection'>
					<ComponentWrapper title='Document Categories' hideBorder>
						<CustomCarousel visibleItems={6}>
							{oneDriveTabs &&
								oneDriveTabs.map(tab => (
									<ActionButton
										id='special-id-1'
										onClick={!isLoading ? () => this.updateView(tab?.name) : () => {}}
										module='support'
										className={viewing === tab?.name ? 'xs selected' : 'xs'}
									>
										<div className='labels21' style={{ color: '#7b868c' }}>
											{tab?.name}
										</div>
									</ActionButton>
								))}
						</CustomCarousel>
					</ComponentWrapper>
				</div>
				<div key={`documents`} className='documents'>
					<ComponentWrapper title='Documents' hideBorder>
						{!hasDownloadDocumentAccess && (
							<div className='body10'>You do not have permission to download documents.</div>
						)}
						<DocumentsDisplay
							data={displayFiles}
							releases={releases}
							isLoading={isLoading}
							viewing={viewing}
							sendingDocument={sendingDocument}
							onClick={sendingDocument ? () => {} : this.downloadDriveItem}
							setModalContent={setModalContent}
							hasDownloadDocumentAccess={hasDownloadDocumentAccess}
						/>

						<PortraitModalComponent
							closeModal={this.toggleNDAModal}
							show={showNDAModal}
							header={this.renderHeader()}
							title='SECURE DOCUMENT'
							subTitle={'NDA AGREEMENT'}
							size={this.getSize(breakpoint)}
							breakpoint={breakpoint}
						>
							{this.NDAModalBody()}
							<ModalFooter
								cypressId='footer'
								id='footer'
								buttonText1='CANCEL'
								buttonText2='CONTINUE'
								module='account'
								buttonFunction1={this.toggleNDAModal}
								buttonFunction2={
									validNDA
										? () => this.handleSendDoc(selectedDocumentId)
										: () => this.handleSendNDASigningDoc()
								}
								size={this.getSize(breakpoint)}
							/>
						</PortraitModalComponent>
					</ComponentWrapper>
				</div>
			</BloxPage>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth_status: state.auth_status,
		company_info: state.company_info,
		theme: state.theme,
		site: state.site_tracking,
		permissions: state.permissions,
	};
}

export default connect(mapStateToProps, {
	updatePage,
	updateModule,
	addPageToBreadCrumbs,
	updatePermissions,
})(DocumentsPage);
